const callbacks = [];
let stripe = null;

function callCallbacks() {
  callbacks.forEach((callback) => callback(stripe));
}

function createScriptTag(publishableKey) {
  if (document.getElementById('stripe-script-tag') != null) {
    return;
  }

  const script = document.createElement('script');
  script.id = 'stripe-script-tag';
  script.type = 'text/javascript';
  script.src = 'https://js.stripe.com/v3/';
  script.async = true;
  script.defer = true;
  script.onload = function stripeLoadCallback() {
    stripe = window.Stripe(publishableKey);
    callCallbacks();
  };
  document.head.appendChild(script);
}

function loadStripe(publishableKey, callback) {
  if (stripe !== null) {
    callback(stripe);
    return;
  }

  callbacks.push(callback);
  createScriptTag(publishableKey);
}

export { loadStripe }; /* eslint-disable-line import/prefer-default-export */
